import React, { useState } from 'react';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/home/Hero';
import { MomentumStrip } from '../components/home/MomentumStrip';
import { MeetCandidate } from '../components/home/MeetCandidate';
import { WhyRunning } from '../components/home/WhyRunning';
import { VisionSection } from '../components/home/VisionSection';
import { AgendaPreview } from '../components/home/AgendaPreview';
import { TrackRecordPreview } from '../components/home/TrackRecordPreview';
import { First100Days } from '../components/home/First100Days';
import { RegionalAgenda } from '../components/home/RegionalAgenda';
import { LatestUpdates } from '../components/home/LatestUpdates';
import { UpcomingEvents } from '../components/home/UpcomingEvents';
import { JoinMovement } from '../components/home/JoinMovement';
import { SupportCampaign } from '../components/home/SupportCampaign';
import { StayConnected } from '../components/home/StayConnected';
import { VideoModal } from '../components/VideoModal';
import { candidate } from '../data/site';
export function Home() {
  const [videoOpen, setVideoOpen] = useState(false);
  return <div className="min-h-screen w-full bg-sand-50" data-id="element-968" data-mp="2mx0g6u4kj78e">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[120] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-[15px] focus:font-semibold focus:text-ink" data-id="element-969" data-mp="2mwgy9dex4iud">
        Skip to content
      </a>

      <AnnouncementBar data-id="element-970" data-mp="2895o9fydx6wd" />
      <Header data-id="element-971" data-mp="288nle0h7vufh" />

      <main id="main" data-id="element-972" data-mp="2861du0ubtex9">
        <Hero onWatch={() => setVideoOpen(true)} data-id="element-973" data-mp="239aw792vib9q" />
        <MomentumStrip data-id="element-974" data-mp="23alzl7seph0b" />
        <MeetCandidate data-id="element-975" data-mp="236y8efafp6or" />
        <WhyRunning onWatch={() => setVideoOpen(true)} data-id="element-976" data-mp="1z7644es2pmp7" />
        <VisionSection data-id="element-977" data-mp="1z6mlswyigwan" />
        <AgendaPreview data-id="element-978" data-mp="1z98wh5gp7rx3" />
        <TrackRecordPreview data-id="element-979" data-mp="1u7t936r1t9bj" />
        <First100Days data-id="element-980" data-mp="1u9nsuhql2ve1" />
        <RegionalAgenda data-id="element-981" data-mp="1uafqrz7nl57h" />
        <LatestUpdates data-id="element-982" data-mp="1kkqpxn7x8si6" />
        <UpcomingEvents data-id="element-983" data-mp="1kkh66hdgzhkx" />
        <JoinMovement data-id="element-984" data-mp="1kj5s9oqb8tg3" />
        <SupportCampaign data-id="element-985" data-mp="1kmtnqtfbfpxg" />
        <StayConnected data-id="element-986" data-mp="1om2hhyacvnt0" />
      </main>

      <Footer data-id="element-987" data-mp="1on3sy3vaacb9" />

      <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} title={`${candidate.name}: Why I am running`} description="A twelve-minute message to Nigerians on delivery, accountability and the standard this campaign is asking to be held to." poster="https://cdn.magicpatterns.com/patterns/generated-images/23fed40f-ca99-4026-a7ba-476691c2f191.jpg" data-id="element-988" data-mp="1onnb9louj2pt" />
    </div>;
}